export default "__VITE_ASSET__CI3stv5R__"